import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZalamoPayRegisterP24Component } from './zalamo-pay-register-p24/zalamo-pay-register-p24.component';
import { FormModule } from '@ui/form/form.module';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ButtonModule } from '@ui/button/button/button.module';
import { PriceSetterModule } from '@ui/price-setter/price-setter.module';
import { ValidationModule } from '@ui/form/validation/validation.module';
import { MatIconModule } from '@angular/material/icon';
import { ZalamoDialogService } from '../zalamo-dialog/zalamo-dialog.service';
import { ZalamoDialogModule } from '@ui/zalamo-dialog/zalamo-dialog.module';
import { SideDialogModule } from '@ui/side-dialog';

@NgModule({
  declarations: [ZalamoPayRegisterP24Component],
  exports: [ZalamoPayRegisterP24Component],
  imports: [
    CommonModule,
    FormModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatInputModule,
    ButtonModule,
    PriceSetterModule,
    ValidationModule,
    MatIconModule,
    ZalamoDialogModule,
    SideDialogModule,
  ],
})
export class ZalamoPayModule {
  constructor(private zalamoDialogService: ZalamoDialogService) {}

  openRegister() {
    const ref = this.zalamoDialogService.open(ZalamoPayRegisterP24Component);
  }
}
